"use client";
import React, { createContext, useContext, useEffect, useMemo } from "react";
import { createAnalytics } from "./analytics";
var AnalyticsContext = createContext(undefined);
export function AnalyticsProvider(_a) {
    var children = _a.children, supabase = _a.supabase, trackSession = _a.trackSession, usePathname = _a.usePathname;
    var pathname = usePathname();
    var analytics = useMemo(function () { return createAnalytics({ supabase: supabase, trackSession: trackSession, pathname: pathname }); }, [supabase, trackSession, pathname]);
    useEffect(function () {
        analytics.trackPageNavigation(pathname);
    }, [analytics, pathname]);
    useEffect(function () {
        return function () {
            analytics.cleanup();
        };
    }, [analytics]);
    return (React.createElement(AnalyticsContext.Provider, { value: analytics }, children));
}
export var useAnalytics = function () {
    var context = useContext(AnalyticsContext);
    if (context === undefined) {
        throw new Error("useAnalytics must be used within an AnalyticsProvider");
    }
    return context;
};
